import { render, staticRenderFns } from "./RootTemplate.vue?vue&type=template&id=5d63307c&scoped=true"
import script from "./RootTemplate.vue?vue&type=script&lang=js"
export * from "./RootTemplate.vue?vue&type=script&lang=js"
import style0 from "./RootTemplate.vue?vue&type=style&index=0&id=5d63307c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d63307c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d63307c')) {
      api.createRecord('5d63307c', component.options)
    } else {
      api.reload('5d63307c', component.options)
    }
    module.hot.accept("./RootTemplate.vue?vue&type=template&id=5d63307c&scoped=true", function () {
      api.rerender('5d63307c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/RootTemplate.vue"
export default component.exports